import React, { useState, useEffect } from 'react';

const downloadDmg = () => {
  const link = document.createElement('a');
  link.href = '/Ghost Text.dmg';
  link.download = 'Ghost Text.dmg';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const navLinks = [
  { href: '#how-it-works', label: 'How it works' },
  { href: '#features', label: 'Features' },
  { href: '#pricing', label: 'Pricing' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled || menuOpen
        ? 'bg-void/85 backdrop-blur-xl border-b border-phantom/10'
        : 'bg-transparent border-b border-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">

          {/* Left - Logo */}
          <a href="/" className="flex items-center space-x-3">
            <img
              src="/GhostText.png"
              alt="Ghost Text logo"
              className="h-9 lg:h-10 w-auto rounded-xl"
            />
            <span className="font-display text-lg lg:text-xl font-bold text-bone">Ghost Text</span>
          </a>

          {/* Center - Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-mist hover:text-phantom font-medium text-sm transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Right - Download Button */}
          <div className="hidden md:flex items-center">
            <button
              onClick={downloadDmg}
              className="btn-primary !px-5 !py-2.5 text-sm"
            >
              Download for macOS
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMenuOpen((open) => !open)}
              className="text-bone p-2"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
            >
              {menuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden pb-6 pt-2 space-y-4 border-t border-phantom/10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="block text-mist hover:text-phantom font-medium py-1 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => { setMenuOpen(false); downloadDmg(); }}
              className="btn-primary w-full text-sm"
            >
              Download for macOS
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
